import type { LanguageConfig } from "./types";

const C_STYLE = { lineComment: "//", blockComment: ["/*", "*/"] as [string, string] };
const HASH = { lineComment: "#" };
const DASH_DASH = { lineComment: "--" };
const XML = { blockComment: ["<!--", "-->"] as [string, string] };

/** Comment syntax for common languages (Linguist/Shiki don't carry it). */
export const COMMENTS: Record<string, LanguageConfig["comments"]> = {
  c: C_STYLE,
  cpp: C_STYLE,
  csharp: C_STYLE,
  java: C_STYLE,
  javascript: C_STYLE,
  jsx: C_STYLE,
  typescript: C_STYLE,
  tsx: C_STYLE,
  go: C_STYLE,
  rust: C_STYLE,
  swift: C_STYLE,
  kotlin: C_STYLE,
  scala: C_STYLE,
  dart: C_STYLE,
  php: C_STYLE,
  "objective-c": C_STYLE,
  zig: { lineComment: "//" },
  css: { blockComment: ["/*", "*/"] },
  scss: C_STYLE,
  less: C_STYLE,
  jsonc: C_STYLE,
  python: { lineComment: "#", blockComment: ['"""', '"""'] },
  ruby: { lineComment: "#", blockComment: ["=begin", "=end"] },
  shellscript: HASH,
  perl: HASH,
  r: HASH,
  yaml: HASH,
  toml: HASH,
  make: HASH,
  docker: HASH,
  elixir: HASH,
  nim: HASH,
  julia: { lineComment: "#", blockComment: ["#=", "=#"] },
  lua: { lineComment: "--", blockComment: ["--[[", "]]"] },
  sql: { lineComment: "--", blockComment: ["/*", "*/"] },
  haskell: { lineComment: "--", blockComment: ["{-", "-}"] },
  elm: { lineComment: "--", blockComment: ["{-", "-}"] },
  ada: DASH_DASH,
  html: XML,
  xml: XML,
  vue: XML,
  svelte: XML,
  markdown: XML,
  clojure: { lineComment: ";" },
  "common-lisp": { lineComment: ";" },
  scheme: { lineComment: ";" },
  erlang: { lineComment: "%" },
  latex: { lineComment: "%" },
  matlab: { lineComment: "%" },
  ini: { lineComment: ";" },
  viml: { lineComment: '"' },
  ocaml: { blockComment: ["(*", "*)"] },
  fsharp: { lineComment: "//", blockComment: ["(*", "*)"] },
};

const BRACKETS: [string, string][] = [
  ["{", "}"],
  ["[", "]"],
  ["(", ")"],
];

const PAIRS = [
  { open: "{", close: "}" },
  { open: "[", close: "]" },
  { open: "(", close: ")" },
  { open: '"', close: '"', notIn: ["string"] },
  { open: "'", close: "'", notIn: ["string", "comment"] },
  { open: "`", close: "`", notIn: ["string", "comment"] },
];

/** Editor behavior for languages without a specific override. */
export function defaultConfig(id: string): LanguageConfig {
  const comments = COMMENTS[id];
  return {
    ...(comments ? { comments } : {}),
    brackets: BRACKETS,
    autoClosingPairs: PAIRS,
    surroundingPairs: PAIRS.map(({ open, close }) => ({ open, close })),
  };
}
